import { Injectable } from "@angular/core";
import { HabitationalRequest } from "../../interfaces/habitational/habitational-request.modal";
import { rate, draft, fullModel, quickQuote, CompanyCode, CompanyName, effectiveDate, expirationDate, auditFrequency, underwriterCode, BusinessName, InsuredType, yearsOfOperation, City, Line1, StateCode, StateDesc, ZipCode, ContactName, Phone1, ProducerCode, producerOfRecord, EMail, primaryState, liabMedicalExpensLmt, prodCompleteOperAggLmt, liabMedicalExpAggLmt, medicalExpensPerPerson, liabilityDeduApp, blanketRating, equipmentBreakdown, cEmpPracLiab, cEpliLimDed, cDoesLocMtf, CNoEmpMore, CNoEmpLess, cIsCyberCov, cCyberOption, cCyberCovLimit, fuelTank, selfStorgFacilEnd, residCleanServCovAp, employeeDishonesty, electronicData, forgeryOrAlteration, interruptionCompOper, businessIncome, hireNonownAutoLiab, hireNonownAutoLiabCov, hireAutoNonownLiabType, hiredAutoLiabLimit, nonownedAutoLiabLmt, nonOwnedAutoLiabCov, compAndFundTranFrd, moldFungiWetDryRot, apartLosDamCusAuto, resLossDamCustAuto, contractorsEndorsement, terrorismCoverage, leadPoisoning, wantGenQstn, referenceObjectId, copyMailingAddress, description, incLmtFireDeptSc, outdoorSigns, moneyAndSecurity, empDishonestyApp, moldFungWetDryRtAp, wtrBckupSmpOvrfl, apartBuildCov, restaurantsCov, locationId, PropertyType, RentalProperty, BuildingSquareFootage, ConstructionType, NumberOfEmployees, DistanceFromFireStation, DistToNearestHydrant, PublicProtFireClas, Interest, OwnerOccupiedSqFtge, cRatingBasis, YearBuilt, NumberOfUnits, NumberOccupiedByOwners, NumberLeasedToOthers, NumberVacant, IsThereABasement, PercentFinished, BldReplacementCostEst, cReconstrConstr, ResAuRepMnufcProcOcup, fireAlarmALocalAlarm, fireAlarmACenStnAlarm, fireAlarmAHrdwrSmkDet, fireAlarmABatopSmkDet, cBurglarLocal, cBurgCentral, bldAnyOtherProtection, BldDeadboltDoorLocks, supplLeadPoisonAppl, fuelTankApplies, dmgPremisesRentYou, dmgPremRentYouSelCov, dmgPremRentYouLimit, swimmingPool, cBusinessIncExcl, offPrmBsnsInter, windstormOrHailExcl, optionalBldgDedu, OptionalPropertyDedu, windstrmHailPrcntDed, autoIncInInsurance, spoilage, comCondUntOwner, condominComUntOwnr, foodContamination, timeElement, directDamage, vacancyPermitEndors, lossPayableClauses, earthquakeCoverage, BldOwnrAndSoleOccupant, BuildingLimitInsurance, includedBlanketRating, incRebudExpFollDis, greenUpgrades, ordinanceLaw, whRoofSurfaceLoss, ltCovAcvBldRc, debrisRemAddInsEndt, ClassCode, BusinssPersonalPropLmt, AreaOccupied, ClassificationPercen, cTenanatRelExp, utlSrvcDirectDmgApp, electronicDataCovApp, intOfCompOprCovApp, incLmtAccountsRecv, incLmtDpndntProp, incLmtPaperRecord, incLmtOutdoorProp, specBppTmpAwayFrmPrm, theftLimitations, brandsAndLabels, permYardsMaintainStr, seasonalIncPercentage, spoilageCovApp, earthquakeCovApplies, medExpensExclusion, amdAggLmtInsrnPrOb, BusinessDesc, otherLocations, CSelectSubmission, cCompPolicy, namePriorInsurer, PriorInsPremium, ListOfPolicies, recentPolCancld, cReasons, YrsExpClass, ContractorResg, snowIceRemoval, privateDriveways, parkingLots, roadHighways, OwnerPartner, EmployeePayroll, TemporaryWorker, totalPayroll, UiSubcontractorPay, GlCertSubcntrsPay, applicantSubcontract, applicantLawsuit, remarkTradeContractors, InsuredConst, BPLocationsConst, name, cRoof, cElectrical, cWaterHeater, cHeating, cPlumbing, autoSprinkleredSystem, leadPoisoningAppl, BPBuildingCoverageConst, BPClassificationsConst, CCompPolicyType, CCompPolicyNumberRef, Extendednamedinsured1, apartmentBldEnd, cEnhancerPlusEndt, enhancerEndorsement, resLosDamCusAutoAp, restEndorsement, BldgPropertyType, LeadPoisonYrConst, LossAssmntSubltForDed, MiscRealPropertyLmt, NoOfUnitsLetterCntrl, bldHaveAFireAlarm, cBurgAlarm, cancelExplanation, condDirctLiabEndt, condLiabEndtLmt, condOffLiabEndtDeduc, lossAssessmentDed, lossAssessmentLmt, resAuRepMnufcProcOcup, BusinessOwnersConst, ProducerConst, ContactConst, LosseHistory, BPLossHistoryGeneralQuestionsConst, CBlgExtRepCc, CExtRpCcOptions, PlayGroundExists, RecFacilities, RiseToClaim, SwimmingPoolExists, BPGeneralQuestionsMUConst, BPCompanionPolicy, BPBuildingConst, cEffectiveAgeOfBldg, BPIRPMOverridefactors, BPIRPMRating, BPIRPMRatingLevel, FactorType, IrpmCovUk, OverrideModifier, OverrideReason, OverrideValue, ProvideBreak, RiskFactor, StateName, TotalModifier, UnderwriterRiskConcern, CCoastalZone, AddressConst, BPInlineOBJConst, CExtendednamedinsured1, businessPersonalProp, classificationDesc, CrmProtAlmACenStAlm, CrmProtAlmALocalAlm, IndRiskPremiumMod, CRecQues, building, cSmallContractor, NumberOfSwimmingPools } from "../../contractor.constant";

@Injectable({
  providedIn: 'root'
})
export class HabitationalDataService {
  constructor() {}

  habitationalData: HabitationalRequest = {
    [rate]: "Y", // hardcoded data from API
    [draft]: "N", // hardcoded data from API
    [fullModel]: "Y", // hardcoded data from API
    [quickQuote]: "N", // hardcoded data from API
    quotePolicy: {
      [CompanyCode]: "80", // backend default
      [CompanyName]: "MAPFRE Insurance Company", // backend default
      [effectiveDate]: "",
      [expirationDate]: "",
      [auditFrequency]: "Non-Auditable", // backend default
      [underwriterCode]: "",
      [InsuredConst]: {
        [BusinessName]: "",
        [InsuredType]: "",
        [yearsOfOperation]: "",
        [AddressConst]: {
          [City]: "",
          [Line1]: "",
          [StateCode]: "",
          [StateDesc]: "",
          [ZipCode]: "",
        },
        [ContactConst]: {
          [ContactName]: "",
          [Phone1]: "",
          [EMail]: ""
        },
        [Extendednamedinsured1]: {
          [CExtendednamedinsured1]: "" // added eventhough it didnt present does not affect coverall
        },
      },
      [ProducerConst]: {
        [ProducerCode]: "",
        [producerOfRecord]: "Y",
        [ContactConst]: {
          [ContactName]: "",
          [EMail]: "",
          [Phone1]: "",
        },
      },
      [BusinessOwnersConst]: {
        [primaryState]: "Massachusetts", // Hardcoded from API
        [liabMedicalExpensLmt]: "1000000",
        [prodCompleteOperAggLmt]: "2000000",
        [liabMedicalExpAggLmt]: "2000000",
        [medicalExpensPerPerson]: "5000",
        [liabilityDeduApp]: "N", // backend default
        [blanketRating]: "N", // backend default
        [IndRiskPremiumMod]: "Y", // backend default
        [equipmentBreakdown]: "Y", // backend default
        [cEmpPracLiab]: "Y",
        [cEpliLimDed]: "25000", // initialize value
        [cDoesLocMtf]: "N",
        [CNoEmpMore]: "",
        [CNoEmpLess]: "",
        [cIsCyberCov]: "",
        [cCyberOption]: "",
        [cCyberCovLimit]: "",
        [fuelTank]: "N", // backend default
        [enhancerEndorsement]: "Y", // backend default 
        [cEnhancerPlusEndt]: "", // new
        [selfStorgFacilEnd]: "N", // backend default
        [residCleanServCovAp]: "N", // backend default
        [employeeDishonesty]: "N", // backend default
        [electronicData]: "N", // backend default
        [forgeryOrAlteration]: "N", // backend default
        [interruptionCompOper]: "N", // backend default
        [businessIncome]: "N", // backend default
        [hireNonownAutoLiab]: "",
        [hireNonownAutoLiabCov]: "",
        [hireAutoNonownLiabType]: "Both", // backend default
        [hiredAutoLiabLimit]: "",
        [nonownedAutoLiabLmt]: "",
        [nonOwnedAutoLiabCov]: "",
        [compAndFundTranFrd]: "N", // backend default
        [moldFungiWetDryRot]: "N", // backend default
        [apartLosDamCusAuto]: "N", // backend default
        [resLossDamCustAuto]: "N", // backend default
        [contractorsEndorsement]: "N", // backend default
        [terrorismCoverage]: "Y", // backend default
        [leadPoisoning]: "N", // default to N change based on YearBuilt 1978
        [wantGenQstn]: "Y", // backend default
        [CBlgExtRepCc]: "",
        [CExtRpCcOptions]: "",
        [BPLocationsConst]: [{
          [referenceObjectId]: "1",
          [copyMailingAddress]: "",
          [name]: "",
          [description]: "",
          [AddressConst]: {
            [City]: "",
            [Line1]: "",
            [StateCode]: "MA",
            [StateDesc]: "Massachusetts",
            [ZipCode]: "",
            [CCoastalZone]: "",
            [cSmallContractor]: ""
          },
          [BPInlineOBJConst]: {
            [incLmtFireDeptSc]: "N", // backend default
            [outdoorSigns]: "N", // backend default
            [moneyAndSecurity]: "N", // backend default
            [empDishonestyApp]: "",
            [moldFungWetDryRtAp]: "",
            [wtrBckupSmpOvrfl]: "N", // backend default
            [apartBuildCov]: "", // backend default
            [apartmentBldEnd]: "", // new - added to interface
            [restaurantsCov]: "N", // backend default
          },
        }],
        [BPBuildingConst]: [{
          [locationId]: "1", 
          [BldgPropertyType]: "Apartments", // new - HARDCODED since Field available only for Habitational
          [PropertyType]: "",
          [building]:"",
          [businessPersonalProp]: "",
          [RentalProperty]: "",
          [BuildingSquareFootage]: "",
          [ConstructionType]: "",
          [NumberOfEmployees]: "0", // HARDCODED FROM CONTRACTOR API CHECK WITH GOPAL
          [DistanceFromFireStation]: "",
          [DistToNearestHydrant]: "",
          [PublicProtFireClas]: "",
          [autoSprinkleredSystem]: "",
          [Interest]: "Owner",
          [OwnerOccupiedSqFtge]: "25000", // HARDCODED FROM CONTRACTOR API CHECK WITH GOPAL
          [cRatingBasis]: "Replacement Cost", // HARDCODED FROM CONTRACTOR API CHECK WITH GOPAL
          [YearBuilt]: "",
          [cEffectiveAgeOfBldg]: "",
          [cRoof]: "",
          [cElectrical]: "",
          [cWaterHeater]: "",
          [cHeating]: "",
          [cPlumbing]: "",
          [NumberOfUnits]: "",
          [NumberOccupiedByOwners]: "",
          [NumberLeasedToOthers]: "",
          [NumberVacant]: "",
          [IsThereABasement]: "N", // backend default
          [PercentFinished]: "",
          [BldReplacementCostEst]: "",
          [cReconstrConstr]: "",
          [resAuRepMnufcProcOcup]: "",
          [bldHaveAFireAlarm]: "Y", // new - HARDCODED SINCE NO FIELD IN UI
          [fireAlarmALocalAlarm]: "",
          [fireAlarmACenStnAlarm]: "",
          [fireAlarmAHrdwrSmkDet]: "",
          [fireAlarmABatopSmkDet]: "",
          [cBurgAlarm]: "", // new
          [CrmProtAlmALocalAlm]: "",
          [CrmProtAlmACenStAlm]: "",
          [bldAnyOtherProtection]: "N/A", // took from sample JSON
          [BldDeadboltDoorLocks]: "Y", // backend default
          [leadPoisoningAppl]: "N", // backend default change based Year Built
          [NoOfUnitsLetterCntrl]: "0", // new - HARCODED CHECK WITH GOPAL
          [LeadPoisonYrConst]: "After 1978", // backend default change based Year Built
          [supplLeadPoisonAppl]: "",
          [fuelTankApplies]: "N", // backend default
          [dmgPremisesRentYou]: "Y", // backend default
          [dmgPremRentYouSelCov]: "Basic", // backend default
          [dmgPremRentYouLimit]: "50000", // field default
          [swimmingPool]: "N", // backend default
          [cBusinessIncExcl]: "N", // backend default
          [offPrmBsnsInter]: "N", // backend default
          [windstormOrHailExcl]: "N", // backend default
          [optionalBldgDedu]: "Y", // backend default
          [OptionalPropertyDedu]: "500", // ui default
          [windstrmHailPrcntDed]: "",
          [autoIncInInsurance]: "", // backend default
          [spoilage]: "N", // backend default
          [comCondUntOwner]: "N", // HARDCODED FROM CONTRACTOR CHECK WITH GOPAL
          [condominComUntOwnr]: "Y", // backend default - NEED WORK
          [lossAssessmentLmt]: "10000", // new -  // backend default
          [MiscRealPropertyLmt]: "5000", // new -  // backend default
          [lossAssessmentDed]: "500", // new // HARDCODED FROM HABITATIONAL API JSON
          [LossAssmntSubltForDed]: "1050", // new // HARDCODED FROM HABITATIONAL API JSON
          [foodContamination]: "N", // backend default
          [timeElement]: "N", // backend default
          [directDamage]: "N", // HARDCODED FROM HABITATIONAL API JSON
          [vacancyPermitEndors]: "N", // backend default
          [lossPayableClauses]: "N", // backend default
          [earthquakeCoverage]: "N", // backend default
          [BldOwnrAndSoleOccupant]: "N", // HARDCODED FROM CONTRACTOR CHECK WITH GOPAL
          [NumberOfSwimmingPools]:"",
          [BPBuildingCoverageConst]: {
            [BuildingLimitInsurance]: "",
            [includedBlanketRating]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [incRebudExpFollDis]: "N", // backend default
            [greenUpgrades]: "N", // backend default
            [ordinanceLaw]: "N", // backend default
            [whRoofSurfaceLoss]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [ltCovAcvBldRc]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [debrisRemAddInsEndt]: "N", // backend default
          },
          [BPClassificationsConst]: {
            [ClassCode]: "",
            [classificationDesc]: "",
            [BusinssPersonalPropLmt]: "",
            [AreaOccupied]: "Percentage", // backend default
            [ClassificationPercen]: "100", // backend default
            [cTenanatRelExp]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [includedBlanketRating]: "N", // backend default
            [greenUpgrades]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [utlSrvcDirectDmgApp]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [electronicDataCovApp]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [intOfCompOprCovApp]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [incLmtAccountsRecv]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [incLmtDpndntProp]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [incLmtPaperRecord]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [incLmtOutdoorProp]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [specBppTmpAwayFrmPrm]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [theftLimitations]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [brandsAndLabels]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [permYardsMaintainStr]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [seasonalIncPercentage]: "25", // backend default
            [spoilageCovApp]: "N", // backend default
            [earthquakeCovApplies]: "N", // backend default
            [condDirctLiabEndt]: "", // new - added to interface
            [condLiabEndtLmt]: "", // new - added to interface
            [condOffLiabEndtDeduc]: "", // new - added to interface
            [medExpensExclusion]: "N", // HARDCODED FROM HABITATIONAL API JSON
            [amdAggLmtInsrnPrOb]: "Y", // HARDCODED FROM HABITATIONAL API JSON
          },
        }],
        [BPIRPMRating]: [
          {
            [ProvideBreak]: "Y", // backend default
            [StateName]: "Massachusetts", // backend default
            [BPIRPMRatingLevel]: [
              {
                [FactorType]: "Both Combined", // backend default
                [IrpmCovUk]: "MA-Both Combined-Both Combined", // backend default
                [OverrideModifier]: "",
                [TotalModifier]: "",
              },
            ],
            [BPIRPMOverridefactors]: [
              {
                [FactorType]: "", //backend default
                [UnderwriterRiskConcern]: "",
                [RiskFactor]: "",
                [OverrideReason]: "",
                [OverrideValue]: "",
                [TotalModifier]: "",
              }
            ],
          },
        ],
        [BPGeneralQuestionsMUConst]: {
          [BusinessDesc]: "",
          [otherLocations]: "",
          [CSelectSubmission]: "New Business Policy to MAPFRE", // backend default
          [BPCompanionPolicy]: {
            [CCompPolicyType]: "",
            [CCompPolicyNumberRef]: "",
          },
          [cCompPolicy]: "N",
          [namePriorInsurer]: "Other", // backend default
          [PriorInsPremium]: "0", // backend default
          [ListOfPolicies]: "None", // backend default
          [recentPolCancld]: "",
          [cReasons]: "",
          [cancelExplanation]: "", // new - added to interface
          [YrsExpClass]: "",
          [LosseHistory]:"",
          [BPLossHistoryGeneralQuestionsConst]: [],
          [ContractorResg]: "123456", // backend default
          [snowIceRemoval]: "N", // backend default
          [privateDriveways]: "N", // HARDCODED FROM HABITATIONAL API JSON
          [parkingLots]: "N", // HARDCODED FROM HABITATIONAL API JSON
          [roadHighways]: "N", // HARDCODED FROM HABITATIONAL API JSON
          [OwnerPartner]: "28600",
          [EmployeePayroll]: "",
          [TemporaryWorker]: "",
          [totalPayroll]: "",
          [UiSubcontractorPay]: "",
          [GlCertSubcntrsPay]: "",
          [applicantSubcontract]: "",
          [applicantLawsuit]: "",
          [remarkTradeContractors]: "",
          [SwimmingPoolExists]: "",
          [PlayGroundExists]: "",
          [RecFacilities]: "",
          [CRecQues]:"",
          [RiseToClaim]: "",
        },
      },
    },
  };
}
